import React from 'react';
import getPercentageForProgressBar from '../../helpers/getPercentageForProgressBar';

export default function Breadcrumbs({ active = [], excludeFirst = false, location }) {
  if (location?.pathname === '/' || location?.pathname === '/warranty-agreement' || location?.pathname === '/support') {
    return null;
  }
  if (location && location.pathname) {
    if (location.pathname === '/pay-check-details') {
      active = [1];
    }
    if (location.pathname === '/display-offered-lease-details') {
      active = [1, 2];
    }
    if (location.pathname === '/checkout') {
      active = [1, 2, 3];
    }
  }
  const items = ['Paycheck Details', 'Review Offer', 'Checkout'];
  if (excludeFirst) {
    items.shift();
    active.shift();
    active = active.map(el => el - 1);
  }
  const getWrapperClass = () => {
    if (excludeFirst) {
      return 'k-breadcrumbs-wrapper k-breadcrumbs-exclude';
    }
    return 'k-breadcrumbs-wrapper';
  };
  return (
    <section className={getWrapperClass()} style={{ height: active.length ? '50px' : '0px' }}>
      <div className="k-breadcrumbs-progress" style={{ width: getPercentageForProgressBar(active, items.length) }} />
      <ul className="k-breadcrumbs">
        {items.map((el, index) => (
          <li key={el} className={active && active.indexOf(index + 1) !== -1 ? 'active' : ''}>
            {el}
          </li>
        ))}
      </ul>
    </section>
  );
}
